import { Box } from '@wix/design-system';
import { HttpClient } from '@wix/http-client';
import {
  MarketingCards,
  PackagePickerAutonomousProvider,
  Title,
  TrustBuilders,
} from '@wix/package-picker-autonomous';
import { WixLogo } from '@wix/package-picker-components';
import { PackagePickerType } from 'enums';
import i18n from 'i18next';
import ICU from 'i18next-icu';
import * as React from 'react';
import { Grid } from './Grid/Grid';
import s from './Sandbox.scss';

const httpClient = new HttpClient();
const selectedPackagePickerType = PackagePickerType.Sunrise;

interface SandboxAppProps {}

export const SandboxApp: React.FC<SandboxAppProps> = () => {
  const isReady = React.useRef(false);
  React.useEffect(() => {
    !isReady.current &&
      i18n.use(ICU).init(() => {
        isReady.current = true;
      });
  }, []);

  if (!isReady.current) {
    return <></>;
  }
  return (
    <PackagePickerAutonomousProvider
      packagePickerType={selectedPackagePickerType}
      apiProps={{ httpClient }}
      translationService={{
        i18n,
        // TODO: fix this!
        Trans: () => <></>,
      }}
    >
      <LogoSection />
      <Header>
        <Title />
      </Header>
      <MarketingCards className={s.cards} />
      <Box margin='36px 0'>
        <TrustBuilders.Banner>
          <TrustBuilders.AcceptedPaymentMethods />
          <TrustBuilders.MoneyBackGuarantee />
          <TrustBuilders.SSLSecurePayment />
        </TrustBuilders.Banner>
      </Box>
      <Box margin='60px'>
        <Grid />
      </Box>
    </PackagePickerAutonomousProvider>
  );
};

const LogoSection = () => {
  return (
    <Box className={s.logo} width='100vw' height='60px'>
      <WixLogo skin='light' />
    </Box>
  );
};

const Header = ({ children }) => {
  return (
    <Box display='flex' className={s.header} width='100vw' height='365px'>
      {children}
    </Box>
  );
};
